import { CUSTOMER_ID } from './config/user-details.const';
import { UserDetailsTypes, UserDetailsUnion } from './actions';
import { UserDetailsState } from './state';

export const initialUserDetailsState: UserDetailsState = {
  currentUser: {
    customerId: undefined,
    email: undefined,
    hasBidCompAccess: false,
    hasMMDAccess: false,
    id: undefined,
    underWriter: undefined,
    error: undefined
  },
  branchDetails: {
    branches: undefined,
    loading: false,
    error: undefined,
    selectedBranch: undefined
  }
};

export function userDetailsReducer(
  state: UserDetailsState = initialUserDetailsState,
  action: UserDetailsUnion
): UserDetailsState {
  switch (action.type) {
    case UserDetailsTypes.LoadCurrentUserSuccess:
      return {
        ...state,
        currentUser: {
          ...action.currentUser,
          error: undefined
        }
      };

    case UserDetailsTypes.LoadCurrentUserFailed:
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          error: action.error
        }
      };

    case UserDetailsTypes.ResetCurrentUser:
      return {
        ...initialUserDetailsState
      };

    case UserDetailsTypes.LoadBranches:
      return {
        ...state,
        branchDetails: {
          ...state.branchDetails,
          loading: !state.branchDetails.branches
        }
      };
    case UserDetailsTypes.LoadBranchesSuccess: {
      const customerId = sessionStorage.getItem(CUSTOMER_ID) ?? state.currentUser.customerId;
      return {
        ...state,
        branchDetails: {
          branches: action.payload,
          loading: false,
          error: undefined,
          selectedBranch: customerId
        }
      };
    }
    case UserDetailsTypes.LoadBranchesFailed:
      return {
        ...state,
        branchDetails: {
          branches: undefined,
          loading: false,
          error: action.error,
          selectedBranch: undefined
        }
      };
    case UserDetailsTypes.UpdateBranch: {
      const customerId = action.customerId;
      return {
        ...state,
        branchDetails: {
          ...state.branchDetails,
          selectedBranch: customerId
        }
      };
    }

    default:
      return {
        ...state
      };
  }
}
